// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Divider } from '@mui/material';
import { ModuleRoute } from '../../routes/types';
import { Collapser } from './Collapser';
import { SidebarItem } from './SidebarItem';
import StyledDrawer from './StyledDrawer';

interface SidebarProps {
  routes: ModuleRoute[];
  notificationCount?: number;
}

export const Sidebar: React.FC<SidebarProps> = ({ routes, notificationCount }) => {
  const [open, setOpen] = React.useState(true);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const menuItems = routes
    .filter((r) => !!r.label && !!r.path)
    .map((i) => {
      return (
        <SidebarItem
          key={i.label}
          drawerOpen={open}
          entry={i}
          notificationCount={i.label === 'notifications' ? notificationCount : 0}
        />
      );
    });

  return (
    <Box sx={{ height: '100%' }}>
      <Collapser open={open} toggleOpen={toggleDrawer} />
      <StyledDrawer variant="permanent" open={open}>
        {menuItems}
        <Divider />
      </StyledDrawer>
    </Box>
  );
};
